import { useRouter } from 'next/router'
import { useState, type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_GURU_PATH } from 'app/KinerjaShared/constants/path'

export interface CardParams {
  cardClasses: string
  icon: string
  title: string
  subtitle: string
  CtaSection?: FC<any>
}

function DialogHowToUpdateData(props: Omit<DialogProps, 'children'>) {
  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Cara Perbarui Data di E-Kinerja" />

        <div className="p-6 flex flex-col gap-4">
          <Text color="subdued">Anda dapat cek video tutorialnya di sini.</Text>

          <Button size="lg" onClick={() => props?.onClose()}>
            Saya mengerti
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export const CONFIG_MATCH_AND_DELIVERED: CardParams = {
  cardClasses: 'border-green-50 bg-surface-success-subdued',
  icon: 'check_circle_outlined',
  title:
    'Data Perencanaan Pengelolaan Kinerja Anda sudah dialirkan ke E-Kinerja',
  subtitle:
    'Data sudah ditampilkan di E-Kinerja. Anda dapat kunjungi E-Kinerja untuk cek jika perlu.',
  CtaSection: () => (
    <>
      <Button
        as="a"
        variant="ghost"
        href="https://kinerja.bkn.go.id/"
        target="_blank"
        className="!px-0"
      >
        Ke E-Kinerja
      </Button>
    </>
  ),
}

export const CONFIG_MATCH_AND_NOT_DELIVERED: CardParams = {
  cardClasses: 'border-interactive-default bg-surface-selected-default',
  icon: 'hourglass_empty_outlined',
  title:
    'Data Perencanaan Pengelolaan Kinerja Anda dalam proses dialirkan ke E-Kinerja',
  subtitle:
    'Proses membutuhkan waktu beberapa saat. Tenang, Anda tidak perlu khawatir selama data sudah tersedia di sini.',
}

export const CONFIG_UNOR_UNMATCH_ORG: CardParams = {
  cardClasses: 'border-critical-default bg-surface-critical-subdued',
  icon: 'warning',
  title:
    'Data Perencanaan Pengelolaan Kinerja Anda belum dialirkan ke E-Kinerja',
  subtitle:
    'Mohon perbarui data satuan pendidikan induk (Unit Kerja) di E-Kinerja. Jika sudah, Anda dapat konfirmasi ulang di sini.',
  CtaSection: () => {
    const [isOpen, setIsOpen] = useState(false)
    const router = useRouter()

    return (
      <div className="pt-3 flex gap-1">
        <Button
          color="black"
          onClick={() => {
            router.push(`${PENGELOLAAN_KINERJA_GURU_PATH}/konfirmasi-unor`)
          }}
        >
          Konfirmasi ulang
        </Button>

        <Button variant="ghost" onClick={() => setIsOpen(true)}>
          Cek cara perbarui data di E-Kinerja
        </Button>

        <DialogHowToUpdateData
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      </div>
    )
  },
}

export const CONFIG_UNOR_UNMATCH_SUPERIOR: CardParams = {
  cardClasses: 'border-critical-default bg-surface-critical-subdued',
  icon: 'warning',
  title:
    'Data Perencanaan Pengelolaan Kinerja Anda belum dialirkan ke E-Kinerja',
  subtitle:
    'Mohon kabari atasan Anda untuk perbarui data di E-Kinerja. Jika sudah, Anda dapat konfirmasi ulang di sini.',
  CtaSection: () => {
    const [isOpen, setIsOpen] = useState(false)
    const router = useRouter()

    return (
      <div className="pt-3 flex gap-1">
        <Button
          color="black"
          onClick={() => {
            router.push(`${PENGELOLAAN_KINERJA_GURU_PATH}/konfirmasi-unor`)
          }}
        >
          Konfirmasi ulang
        </Button>

        <Button variant="ghost" onClick={() => setIsOpen(true)}>
          Cek selengkapnya
        </Button>

        <DialogHowToUpdateData
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      </div>
    )
  },
}

export const CONFIG_UNOR_UNMATCH: CardParams = {
  cardClasses: 'border-critical-default bg-surface-critical-subdued',
  icon: 'warning',
  title:
    'Data Perencanaan Pengelolaan Kinerja Anda belum dialirkan ke E-Kinerja',
  subtitle:
    'Mohon perbarui data satuan pendidikan induk (Unit Kerja) di E-Kinerja dan kabari atasan Anda untuk perbarui data di E-Kinerja. Jika sudah, Anda dapat konfirmasi ulang di sini.',
  CtaSection: () => {
    const [isOpen, setIsOpen] = useState(false)
    const router = useRouter()

    return (
      <div className="pt-3 flex gap-1">
        <Button
          color="black"
          onClick={() => {
            router.push(`${PENGELOLAAN_KINERJA_GURU_PATH}/konfirmasi-unor`)
          }}
        >
          Konfirmasi ulang
        </Button>

        <Button variant="ghost" onClick={() => setIsOpen(true)}>
          Cek selengkapnya
        </Button>

        <DialogHowToUpdateData
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      </div>
    )
  },
}
